const calculatorsData = {
  SY: [
    {
      name: "حاسبة معدل السنة التحضيرية",
      url: "/calculator/ar/countries/SY/calculators-list/preparatory-year-calculator/",
      showMain: true,
    },
    {
      name: "حاسبة استهلاك الكهرباء في سوريا",
      url: "/calculator/ar/countries/SY/calculators-list/electricity-calculator/",
      showMain: true,
    },
    {
      name: "حاسبة تكلفة استهلاك المياه في سوريا",
      url: "/calculator/ar/countries/SY/calculators-list/water-calculator/",
      showMain: true,
    },
    {
      name: "حاسبة تكلفة استهلاك المحروقات في سوريا",
      url: "/calculator/ar/countries/SY/calculators-list/fuel-calculator/",
      showMain: true,
    },
  ],
  SA: [
    {
      name: "حاسبة الأوفر تايم في السعودية",
      url: "/calculator/ar/countries/SA/calculators-list/overtime-calculator/",
      showMain: true,
    },
    {
      name: "حاسبة الضمان المطور في السعودية",
      url: "/calculator/ar/countries/SA/calculators-list/advanced-social-security/",
      showMain: true,
    },
    {
      name: "حاسبة الضمان الاجتماعي في السعودية",
      url: "/calculator/ar/countries/SA/calculators-list/social-security-calculator/",
      showMain: true,
    },
    {
      name: "حاسبة النطاقات - حساب مستوى التوطين في السعودية",
      url: "/calculator/ar/countries/SA/calculators-list/nitaqat-calculator/",
      showMain: true,
    },
       {
      name: "حاسبة استهلاك الكهرباء في السعودية",
      url: "/calculator/ar/countries/SA/calculators-list/electricity-calculator/",
      showMain: true,
    },
  ],
  EG: [
    {
      name: "حاسبة استهلاك الكهرباء في مصر",
      url: "/calculator/ar/countries/EG/calculators-list/electricity-calculator/",
      showMain: true,
    },
  ],
    JO: [
    {
      name: "حاسبة استهلاك الكهرباء في الأردن",
      url: "/calculator/ar/countries/JO/calculators-list/electricity-calculator/",
      showMain: true,
    },
  ],
};
export default calculatorsData;
